import { VForm } from 'vuetify/lib/components/VForm';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "devicetype-packetparser"
  }, [_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c('niota-classic-devicetypes-packet-parser-default', {
    attrs: {
      "parserConfig": _vm.parserConfigInternal,
      "readonly": _vm.readonly,
      "hide-predefined-parser-selection": _vm.hidePredefinedParserSelection
    },
    on: {
      "config-updated": _vm.onConfigChanged,
      "validate-form": function ($event) {
        return _vm.$refs.form.validate();
      }
    }
  }), _c('niota-classic-devicetypes-packet-parser-type-definitions', {
    attrs: {
      "variables": _vm.parserConfigInternal.variables,
      "custom": _vm.parserConfigInternal.custom,
      "calculate-elements": _vm.parserConfigInternal.calculateElements,
      "parse-elements": _vm.parserConfigInternal.parseElements,
      "readonly": _vm.readonly
    },
    on: {
      "variables-updated": _vm.onTypeDefinitionsUpdated
    }
  })], 1), _c('niota-classic-devicetypes-packet-parser-payload-test', {
    attrs: {
      "parserConfig": _vm.parserConfigInternal,
      "readonly": _vm.readonly,
      "accountId": _vm.accountId,
      "parserType": "single",
      "custom-test-function": _vm.customTestFunction
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };